import { render, staticRenderFns } from "./JudgeResult.vue?vue&type=template&id=6fa0d87a&scoped=true&"
import script from "./JudgeResult.vue?vue&type=script&lang=js&"
export * from "./JudgeResult.vue?vue&type=script&lang=js&"
import style0 from "./JudgeResult.vue?vue&type=style&index=0&id=6fa0d87a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa0d87a",
  null
  
)

export default component.exports